export default {
  //  revenueSummary,
  'salesSummary.revenueSummary.title': '销售汇总',
  'salesSummary.revenueSummary.net_sales': '净销售额',
  'salesSummary.revenueSummary.tax_amount': '税',
  'salesSummary.revenueSummary.grand_total': '税后销售额',
  'salesSummary.revenueSummary.fee_amount': '费用',
  'salesSummary.revenueSummary.tips': '小费',
  'salesSummary.revenueSummary.service_tips': '服务小费',
  'salesSummary.revenueSummary.delivery_tips': '递送小费',
  'salesSummary.revenueSummary.comps': '补偿',
  'salesSummary.revenueSummary.deferred_sales': '预付金额',
  'salesSummary.revenueSummary.sales_revenue': '销售收入',
  'salesSummary.revenueSummary.excess_payments': '超额付款',
  'salesSummary.revenueSummary.total_revenue': '总计',

  //  orderSummary,
  'salesSummary.orderSummary.title': '订单汇总',
  'salesSummary.orderSummary.closed_orders': '完成订单数',
  'salesSummary.orderSummary.open_orders': '未完成订单数',
  'salesSummary.orderSummary.canceled_orders': '已取消订单数',

  //  netSalesSummary,
  'salesSummary.netSalesSummary.title': '净销售额汇总',
  'salesSummary.netSalesSummary.gross_sales': '总销售额',
  'salesSummary.netSalesSummary.discounts': '折扣',
  'salesSummary.netSalesSummary.refunds': '退款',
  'salesSummary.netSalesSummary.net_sales': '净销售额',

  //  paymentsSummary,
  'salesSummary.paymentsSummary.title': '付款汇总',
  'salesSummary.paymentsSummary.card': '刷卡',
  'salesSummary.paymentsSummary.amex': 'Amex',
  'salesSummary.paymentsSummary.discover': 'Discover',
  'salesSummary.paymentsSummary.mastercard': 'Mastercard',
  'salesSummary.paymentsSummary.visa': 'Visa',
  'salesSummary.paymentsSummary.cash': '现金',
  'salesSummary.paymentsSummary.online': '线上',
  'salesSummary.paymentsSummary.other': '其他',
  'salesSummary.paymentsSummary.loyalty': '会员账户余额',
  'salesSummary.paymentsSummary.gift_card': '礼品卡',
  'salesSummary.paymentsSummary.total': '付款总计',

  'salesSummary.paymentsSummary.columns.pmt_method': '付款方式',
  'salesSummary.paymentsSummary.columns.count': '数量',
  'salesSummary.paymentsSummary.columns.amount': '金额',
  'salesSummary.paymentsSummary.columns.tips': '小费',
  'salesSummary.paymentsSummary.columns.non-tips': '非小费',
  'salesSummary.paymentsSummary.columns.refunds': '退款',
  'salesSummary.paymentsSummary.columns.gross_amount': '退款前金额',

  //  tipsSummary,
  'salesSummary.tipsSummary.title': '小费汇总',
  'salesSummary.tipsSummary.card': '刷卡',
  'salesSummary.tipsSummary.cash': '现金',
  'salesSummary.tipsSummary.other': '其他',
  'salesSummary.tipsSummary.total': '总计',

  'salesSummary.tipsSummary.columns.pmt_method': '付款方式',
  'salesSummary.tipsSummary.columns.service_tips': '服务小费',
  'salesSummary.tipsSummary.columns.delivery_tips': '递送小费',

  //  discountSummary,
  'salesSummary.discountSummary.title': '折扣汇总',
  'salesSummary.discountSummary.one-off_discount': '一次性折扣',
  'salesSummary.discountSummary.loyalty': '会员',
  'salesSummary.discountSummary.promotion': '促销',
  'salesSummary.discountSummary.total': '总计',

  'salesSummary.discountSummary.columns.discount': '折扣',
  'salesSummary.discountSummary.columns.count': '数量',
  'salesSummary.discountSummary.columns.amount': '金额',

  //  breakdownOfGratuityAndTips,
  'salesSummary.breakdownOfGratuityAndTips.title': '小费细分服务费和小费',
  'salesSummary.breakdownOfGratuityAndTips.gratuity': '服务费',
  'salesSummary.breakdownOfGratuityAndTips.tips': '小费',
  'salesSummary.breakdownOfGratuityAndTips.card': '刷卡',
  'salesSummary.breakdownOfGratuityAndTips.cash': '现金',
  'salesSummary.breakdownOfGratuityAndTips.other': '其他',
  'salesSummary.breakdownOfGratuityAndTips.total': '总计',

  'salesSummary.breakdownOfGratuityAndTips.columns.type': '类型',
  'salesSummary.breakdownOfGratuityAndTips.columns.service_tips': '服务小费',
  'salesSummary.breakdownOfGratuityAndTips.columns.delivery_tips': '递送小费',

  //  feesSummary,
  'salesSummary.feesSummary.title': '费用汇总',
  'salesSummary.feesSummary.non-taxable_fees': '免税费用',
  'salesSummary.feesSummary.18%_gratuity': '18% 小费',
  'salesSummary.feesSummary.cc_fee': 'CC 非',
  'salesSummary.feesSummary.taxable_fees': '征税费用',
  'salesSummary.feesSummary.delivery_fee': '递送费',
  'salesSummary.feesSummary.package_fee': '打包费',
  'salesSummary.feesSummary.total': '总计',

  'salesSummary.feesSummary.columns.fee': '费用',
  'salesSummary.feesSummary.columns.amount': '金额',

  //  employeeTipsAccount,
  'salesSummary.employeeTipsAccount.title': '员工小费账户',
  'salesSummary.employeeTipsAccount.total_service_tips': '服务小费总计',
  'salesSummary.employeeTipsAccount.tip_out': '小费分出',
  'salesSummary.employeeTipsAccount.tips_owed_to_employee': '员工应得小费',

  //  deferredSalesSummary,
  'salesSummary.deferredSalesSummary.title': '预付销售汇总',
  'salesSummary.deferredSalesSummary.gift_card': '礼品卡',
  'salesSummary.deferredSalesSummary.loyalty_prepaid': '会员卡充值',
  'salesSummary.deferredSalesSummary.annual_mem._fee': '会员年费',
  'salesSummary.deferredSalesSummary.card': '刷卡',
  'salesSummary.deferredSalesSummary.cash': '现金',
  'salesSummary.deferredSalesSummary.other': '其他',
  'salesSummary.deferredSalesSummary.total': '总计',

  'salesSummary.deferredSalesSummary.columns.type': '类型',
  'salesSummary.deferredSalesSummary.columns.count': '数量',
  'salesSummary.deferredSalesSummary.columns.amount': '金额',

  //  voidSummary,
  'salesSummary.voidSummary.title': '作废汇总',
  'salesSummary.voidSummary.void_amount': '作废金额',
  'salesSummary.voidSummary.void_oder_count': '作废订单数',
  'salesSummary.voidSummary.void_item_count': '作废菜品数',

  //  cashDrawerExpectedBalance,
  'salesSummary.cashDrawerExpectedBalance.title': '钱箱预计余额',
  'salesSummary.cashDrawerExpectedBalance.cash_sales': '现金收入',
  'salesSummary.cashDrawerExpectedBalance.cash_tips': '现金小费',
  'salesSummary.cashDrawerExpectedBalance.miscellaneous_cash': '杂项收入',
  'salesSummary.cashDrawerExpectedBalance.starting_balance': '初始金额',
  'salesSummary.cashDrawerExpectedBalance.cash_in_other': '其他原因',
  'salesSummary.cashDrawerExpectedBalance.total_cash_in': '入账合计',
  'salesSummary.cashDrawerExpectedBalance.cash_refund': '现金退款',
  'salesSummary.cashDrawerExpectedBalance.employee_reimbursement': '员工报销',
  'salesSummary.cashDrawerExpectedBalance.cash_out_other': '其他原因',
  'salesSummary.cashDrawerExpectedBalance.safe_drop': '保险箱提款',
  'salesSummary.cashDrawerExpectedBalance.tips_payout': '发放小费',
  'salesSummary.cashDrawerExpectedBalance.total_cash_out': '出账合计',
  'salesSummary.cashDrawerExpectedBalance.balance': '余额',

  //  refundsSummary,
  'salesSummary.refundsSummary.title': '退款汇总',
  'salesSummary.refundsSummary.sales_refunds': '销售退款',
  'salesSummary.refundsSummary.tax_refunds': '税退款',
  'salesSummary.refundsSummary.fee_refunds': '费用退款',
  'salesSummary.refundsSummary.tips_refunds': '小费退款',
  'salesSummary.refundsSummary.reopen_refunds': '重开单退款',
  'salesSummary.refundsSummary.payment_refunds': '支付退款',
  'salesSummary.refundsSummary.total_refunds': '退款总计',

  //  dineInGuests,
  'salesSummary.dineInGuests.title': '堂食客人数量',
  'salesSummary.dineInGuests.columns.order_source': '订单来源',
  'salesSummary.dineInGuests.columns.guests': '客人数',

  //  houseCash,
  'salesSummary.houseCash.title': '餐厅现金总计',
  'salesSummary.houseCash.cash_total_in_hand': '持有现金总计',
  'salesSummary.houseCash.non-delivery': '非递送现金',
  'salesSummary.houseCash.delivery': '递送现金',
  'salesSummary.houseCash.in-house_cash_service_tips': '堂食现金服务小费',
  'salesSummary.houseCash.in-house_card_service_tips': '堂食刷卡服务小费',
  'salesSummary.houseCash.in-house_other_service_tips': '堂食其他服务小费',
  'salesSummary.houseCash.in-house_card_service_tips_withholding': '堂食刷卡服务小费代扣',
  'salesSummary.houseCash.in-house_net_sales_withholding': '堂食净销售额代扣',
  'salesSummary.houseCash.online_service_tips': '线上服务小费',
  'salesSummary.houseCash.online_service_tips_withholding': '线上服务小费代扣',
  'salesSummary.houseCash.in-house_cash_delivery_tips': '堂食现金递送小费',
  'salesSummary.houseCash.in-house_card_delivery_tips': '堂食刷卡递送小费',
  'salesSummary.houseCash.in-house_other_delivery_tips': '堂食其他递送小费',
  'salesSummary.houseCash.in-house_delivery_fee': '堂食递送费',
  'salesSummary.houseCash.in-house_card_delivery_tips_withholding': '堂食刷卡递送小费代扣',
  'salesSummary.houseCash.online_delivery_tips': '线上递送小费',
  'salesSummary.houseCash.online_delivery_fee': '线上递送费',
  'salesSummary.houseCash.online_delivery_tips_withholding': '线上递送小费代扣',
  'salesSummary.houseCash.cash_owed_to_house': '应付餐厅现金',

  //  netSalesMetrics,
  'salesSummary.netSalesMetrics.title': '净销售额分析指标',
  'salesSummary.netSalesMetrics.total_orders': '总订单数',
  'salesSummary.netSalesMetrics.net_sales_total_orders': '平均每单净销售额',
  'salesSummary.netSalesMetrics.total_items': '总菜品数',
  'salesSummary.netSalesMetrics.net_sales_total_items': '平均每菜净销售额',
  'salesSummary.netSalesMetrics.dine-in_guests': '堂食客人数',
  'salesSummary.netSalesMetrics.net_sales_total_guests': '平均每客净销售额',

  //  orderSourcesSummary,
  'salesSummary.orderSourcesSummary.title': '销售收入细分订单来源',
  'salesSummary.orderSourcesSummary.total': '总计',

  'salesSummary.orderSourcesSummary.columns.source': '来源',
  'salesSummary.orderSourcesSummary.columns.orders': '订单数',
  'salesSummary.orderSourcesSummary.columns.net_sales': '净销售额',
  'salesSummary.orderSourcesSummary.columns.discounts': '折扣',
  'salesSummary.orderSourcesSummary.columns.service_tips': '服务小费',
  'salesSummary.orderSourcesSummary.columns.delivery_tips': '递送小费',
  'salesSummary.orderSourcesSummary.columns.revenue': '销售收入',

  //  onlinePlatformsSummary,
  'salesSummary.onlinePlatformsSummary.title': '销售收入细分线上平台',

  'salesSummary.onlinePlatformsSummary.columns.platform': '平台',
  'salesSummary.onlinePlatformsSummary.columns.orders': '订单数',
  'salesSummary.onlinePlatformsSummary.columns.net_sales': '净销售额',
  'salesSummary.onlinePlatformsSummary.columns.discounts': '折扣',
  'salesSummary.onlinePlatformsSummary.columns.service_tips': '服务小费',
  'salesSummary.onlinePlatformsSummary.columns.delivery_tips': '递送小费',
  'salesSummary.onlinePlatformsSummary.columns.revenue': '销售收入',

  //  serviceTypesSummary,
  'salesSummary.serviceTypesSummary.title': '销售收入细分服务类型',
  'salesSummary.serviceTypesSummary.total': '总计',

  'salesSummary.serviceTypesSummary.columns.type': '类型',
  'salesSummary.serviceTypesSummary.columns.orders': '订单数',
  'salesSummary.serviceTypesSummary.columns.net_sales': '净销售额',
  'salesSummary.serviceTypesSummary.columns.discounts': '折扣',
  'salesSummary.serviceTypesSummary.columns.service_tips': '服务小费',
  'salesSummary.serviceTypesSummary.columns.delivery_tips': '递送小费',
  'salesSummary.serviceTypesSummary.columns.revenue': '销售收入',

  'salesSummary.orderSources.walk_in': '到店点餐',
  'salesSummary.orderSources.call_in': '电话订餐',
  'salesSummary.orderSources.qr_code': '扫码点餐',
  'salesSummary.orderSources.kiosk': '自助点餐机',
  'salesSummary.orderSources.terminal': '支付终端',
  'salesSummary.orderSources.external': '外部系统',
  'salesSummary.orderSources.loyalty': '会员系统',
  'salesSummary.orderSources.online': '线上订餐',

  'salesSummary.orderSources.total': '总计',

  //service type
  'salesSummary.serviceType.dine_in': '堂食',
  'salesSummary.serviceType.take_out': '外带',
  'salesSummary.serviceType.delivery': '递送',
  'salesSummary.serviceType.other': '其他',
  'salesSummary.serviceType.total': '总计',

  'salesSummary.timeWarning': '请选择不超过一个月的日期范围',

  //section sales
  'sectionSales.table.title': '区域销售',
  'sectionSales.columns.name': '名称',
  'sectionSales.columns.order_count': '订单数',
  'sectionSales.columns.gross_sales': '税前营业额',
  'sectionSales.columns.discounts': '折扣',
  'sectionSales.columns.net_sales': '销售额',
  'sectionSales.columns.taxes': '税额',
  'sectionSales.columns.service_tips': '服务小费',

  'sectionSales.summary.total': '销售总计',
};
